module.exports = __webpack_public_path__ + "img/head-mv06.ee0692f8.jpg";